// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3gEfI","productName":"Table_productName__24Ht-"};